import { Controller } from "remult";

@Controller("user-population-preference-methods")
export class UserPopulationPreferenceMethods {}




